export default function SolutionsDashboardView() {
    return (
        <section>
            Dashboard admin SOLUTIONS
        </section>
    )
}